import React from 'react';

interface HotIconProps {
  size?: number;
  className?: string;
  fill?: string;
  [key: string]: any;
}

const HotIcon: React.FC<HotIconProps> = ({ size = 14, className = '', fill = 'white', ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_8931_71679)">
        <path
          d="M4.38883 14C3.45591 12.0586 3.95261 10.9462 4.66966 9.89788C5.45503 8.75021 5.65746 7.61374 5.65746 7.61374C5.65746 7.61374 6.27483 8.41618 6.02788 9.67137C7.11844 8.45734 7.32423 6.52318 7.1596 5.78233C9.62462 7.5051 10.6782 11.2351 9.2584 13.9997C16.81 9.72709 11.1368 3.33383 10.149 2.61342C10.4783 3.33355 10.5407 4.55262 9.87549 5.14423C8.74966 0.874965 5.96601 0 5.96601 0C6.29527 2.20155 4.77241 4.60918 3.30415 6.4081C3.25264 5.53006 3.19776 4.92444 2.73606 4.0842C2.63246 5.67901 1.41367 6.979 1.08356 8.5769C0.63642 10.7409 1.41843 12.3254 4.38855 13.9992L4.38883 14Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_8931_71679">
          <rect width="14" height="14" fill={fill} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HotIcon;